import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Plus } from "lucide-react";
import { Eyebrow, Reveal } from "./Reveal";
import { faqs } from "../data/business";

export default function FAQ() {
    const [open, setOpen] = useState(0);

    return (
        <section
            data-testid="faq-section"
            className="border-y border-line bg-cream py-20 sm:py-28 lg:py-36"
        >
            <div className="mx-auto grid max-w-7xl grid-cols-1 gap-12 px-4 sm:px-8 lg:grid-cols-12 lg:px-16">
                <div className="lg:col-span-4">
                    <Eyebrow>Dúvidas frequentes</Eyebrow>
                    <Reveal delay={0.1}>
                        <h2 className="mt-5 font-display text-3xl font-medium uppercase leading-[1.1] tracking-tight text-ink sm:text-4xl">
                            Ainda tem alguma
                            <span className="italic text-accent"> dúvida?</span>
                        </h2>
                    </Reveal>
                    <Reveal delay={0.2}>
                        <p className="mt-5 text-sm text-ink-soft">
                            Respostas rápidas para as perguntas mais comuns. Para
                            qualquer outra dúvida, fale diretamente com nossa equipe.
                        </p>
                    </Reveal>
                </div>

                <div className="lg:col-span-8">
                    <div className="border-t border-line">
                        {faqs.map((f, i) => (
                            <Reveal key={f.q} delay={i * 0.06}>
                                <div className="border-b border-line">
                                    <button
                                        data-testid={`faq-item-${i + 1}`}
                                        onClick={() => setOpen(open === i ? -1 : i)}
                                        aria-expanded={open === i}
                                        className="flex w-full items-center justify-between gap-6 py-6 text-left"
                                    >
                                        <span className="font-display text-lg font-semibold text-ink sm:text-xl">
                                            {f.q}
                                        </span>
                                        <Plus
                                            size={18}
                                            className={`shrink-0 text-accent transition-transform duration-300 ${
                                                open === i ? "rotate-45" : ""
                                            }`}
                                        />
                                    </button>
                                    <AnimatePresence initial={false}>
                                        {open === i && (
                                            <motion.div
                                                initial={{ height: 0, opacity: 0 }}
                                                animate={{ height: "auto", opacity: 1 }}
                                                exit={{ height: 0, opacity: 0 }}
                                                transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
                                                className="overflow-hidden"
                                            >
                                                <p className="max-w-2xl pb-6 text-sm leading-relaxed text-ink-soft">
                                                    {f.a}
                                                </p>
                                            </motion.div>
                                        )}
                                    </AnimatePresence>
                                </div>
                            </Reveal>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
